var _path, _path2;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
class IconUndoLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return _jsxs(SVGIcon, {
      ...this.props,
      name: "IconUndo",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      bidirectional: true,
      children: [_path || (_path = _jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M646.365 53.3336L738.853 145.821L250.382 634.291L1278.71 634.167V765.312L250.382 765.108L738.853 1253.71L646.365 1346.2L-0.00188191 699.7L646.365 53.3336Z",
        fill: "#273540"
      })), _path2 || (_path2 = _jsx("path", {
        d: "M1278.71 765.312C1541.45 772.29 1777.18 987.357 1777.19 1251.77C1777.19 1516.19 1566.39 1731.14 1303.65 1738.12V1866.67C1467.08 1866.67 1623.81 1801.71 1739.38 1686.15C1854.94 1570.58 1919.89 1413.86 1919.9 1250.42C1919.9 1086.97 1854.95 930.258 1739.38 814.687C1623.8 699.117 1442.15 634.167 1278.71 634.167V765.312Z",
        fill: "#273540"
      }))]
    });
  }
}
IconUndoLine.glyphName = 'undo';
IconUndoLine.variant = 'Line';
IconUndoLine.displayName = 'IconUndoLine';
IconUndoLine.allowedProps = [...SVGIcon.allowedProps];
export default IconUndoLine;
export { IconUndoLine };